import { Table } from "rsuite";

const { Column, HeaderCell, Cell } = Table;

const TableComponents = ({ data, config, actions, content, loading,  onRowClick }) => {

  return (
    <Table
    loading={loading}
      virtualized
      height={400}
      data= {data}
      onRowClick={(item)=>onRowClick(item)}
    >
      {config.map((c) => (
        <Column flexGrow={!c.width? 1 : 0} width={c.width} align="center" fixed={c.fixed}>
          <HeaderCell>{c.label}</HeaderCell>
          {!c.content? ( < Cell dataKey={c.key} /> ):( <Cell>
            {(item)=> c.content(item)}
          </Cell>)}
         
        </Column>
      ))}
      <Column  width={150}  fixed="right">
          <HeaderCell>Ações</HeaderCell>
          <Cell>
            {(item)=> actions(item)}
          </Cell>
        </Column>
    </Table>
  );
};

export default TableComponents;
